import React from 'react';

import PlaceholderText from 'ui-library/PlaceholderText';

import {Optional} from '../util/Types';

interface Props {
  value: Optional<string>;
  placeholder?: string | null;
}

/**
 * Renders a long text value or 'No Value' if it is empty.
 */
export default function LongTextValue({value, placeholder}: Props): JSX.Element {
  return value ? (
    <span className="textValue u-pre-line">{value}</span>
  ) : (
    <PlaceholderText value={placeholder} />
  );
}
